import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideTranslateService } from '@ngx-translate/core';
import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
  withHttpTransferCacheOptions,
} from '@angular/platform-browser';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideToastr } from 'ngx-toastr';
import { authenticationInterceptor } from './core/interceptors/authentication/authentication.interceptor';
import { errorsInterceptor } from './core/interceptors/errors/errors.interceptor';
import { languageInterceptor } from './core/interceptors/language/language.interceptor';
import { requestCountInterceptor } from './core/interceptors/request-count/request-count.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withRouterConfig({
        paramsInheritanceStrategy: 'always',
      })
    ),
    provideClientHydration(
      withEventReplay(),
      withHttpTransferCacheOptions({
        includePostRequests: false,
        includeRequestsWithAuthHeaders: true,
      })
    ),
    provideTranslateService({
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({
        prefix: './i18n/',
        suffix: '.json',
        enforceLoading: true,
        useHttpBackend: true,
      }),
    }),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        requestCountInterceptor,
        errorsInterceptor,
        languageInterceptor,
        authenticationInterceptor,
      ])
    ),
    provideToastr({ countDuplicates: true, preventDuplicates: true }),
  ],
};
